import "./wardControl.css";
//import wardsData from "../../data/wards.geojson";
import { wardsData } from "../../data/wards";
import { pc } from "../../data/pc";

const maplibregl = window.maplibregl;

const pcFilter = [
    "case",
    ["<", ["zoom"], 8],
    ["==", ["get", "l"], null],
    [">=", ["zoom"], 11],
    ["==", ["get", "l"], 2],
    ["==", ["get", "l"], 1]
];

class wardControl {
    constructor(options) {
        this.layers = [
            {
                id: "wards",
                data: wardsData,
                title: "Wards Boundaries"
            },
            {
                id: "pc",
                data: pc,
                title: "Postcodes",
                //filter: ["==", ["get", "l"], null]
                // filter: ["==", ["get", "l"], 1]
                filter: pcFilter
            }
        ];

        this._options = { ...options };
        this._container = document.createElement("div");

        this.layers = this.layers.map((layer) => ({
            ...layer,
            showNames: false // Добавляем состояние для хранения значения show names
        }));

        this.layers.forEach((layer) => {
            const wrapper = document.createElement("div");

            const mainLabel = document.createElement("label");
            mainLabel.setAttribute("for", `${layer.id}-control`);

            const input = document.createElement("input");
            input.type = "checkbox";
            input.id = `${layer.id}-control`;
            layer.checkbox = input;

            mainLabel.appendChild(input);
            mainLabel.appendChild(document.createTextNode(` ${layer.title}`));
            wrapper.appendChild(mainLabel);

            // Создаем checkbox для отображения названий
            const namesWrapper = document.createElement("div");
            namesWrapper.style.marginLeft = "20px";
            namesWrapper.style.display = "none"; // Изначально скрыт

            const namesLabel = document.createElement("label");
            namesLabel.setAttribute("for", `${layer.id}-names-control`);

            const namesInput = document.createElement("input");
            namesInput.type = "checkbox";
            namesInput.id = `${layer.id}-names-control`;
            layer.namesCheckbox = namesInput;

            namesLabel.appendChild(namesInput);
            namesLabel.appendChild(document.createTextNode(" Show names"));
            namesWrapper.appendChild(namesLabel);
            layer.namesWrapper = namesWrapper;

            wrapper.appendChild(namesWrapper);
            this._container.appendChild(wrapper);
        });

        this._container.classList.add("maplibregl-ctrl");
        this._container.classList.add("maplibregl-ctrl-wards");

        this.layerClickedBinded = this.layerClicked.bind(this);
    }

    onAdd(map) {
        this._map = map;

        this.popup = new maplibregl.Popup({ closeOnClick: true });

        this.layers.forEach((layer) => {
            layer.checkbox.addEventListener("change", (e) => {
                if (e.target.checked) {
                    // off another layers
                    this.layers.forEach((otherLayer) => {
                        if (otherLayer.id !== layer.id) {
                            otherLayer.checkbox.checked = false;
                            otherLayer.namesWrapper.style.display = "none";
                            this.removeLayer(otherLayer);
                        }
                    });

                    layer.namesWrapper.style.display = "block";
                    layer.namesCheckbox.checked = layer.showNames; // Восстанавливаем состояние
                    this.addLayer(layer);
                    if (layer.showNames) {
                        // Если было включено, показываем метки
                        this.addLabels(layer);
                    }
                } else {
                    layer.namesWrapper.style.display = "none";
                    layer.showNames = layer.namesCheckbox.checked; // Сохраняем состояние
                    this.removeLayer(layer);
                }
            });

            layer.namesCheckbox.addEventListener("change", (e) => {
                layer.showNames = e.target.checked; // Обновляем состояние
                if (e.target.checked) {
                    this.addLabels(layer);
                } else {
                    this.removeLabels(layer);
                }
            });
        });

        return this._container;
    }

    layerClicked(e) {
        const isInProcess =
            this._options.model.drawing ||
            this._options.model.modify ||
            this._options.model.delete ||
            this._options.model.changeColor ||
            this._options.model.addRoad ||
            this._options.model.selectRoads ||
            this._options.model.splitRoads ||
            this._options.model.exportPDF;

        if (isInProcess || this._options.model.mapEngine.householdsPopup.isOpen()) {
            return;
        }

        const feature = e.features[0];
        if (feature) {
            let content = "";
            let extra = "";
            if (feature.layer.source === "pc") {
                content = feature.properties.name;
                if (feature.properties.c) {
                    extra = `<p  style="margin: 0;">Households: ${feature.properties.c}</p>`;
                }
            } else {
                content = feature.properties.WD24NM;
            }

            this.popup.setLngLat(e.lngLat).setHTML(`<h3 style="margin: 0;">${content}</h3>${extra}`).addTo(this._map);
        }
    }

    addLayer(layer) {
        const source = this._map.getSource(layer.id);
        if (!source) {
            this._map.addSource(layer.id, {
                type: "geojson",
                data: layer.data
            });
        }

        const fillStyle = {
            id: `wards-fill-${layer.id}`,
            type: "fill",
            source: layer.id,
            paint: {
                "fill-color": "#5D9AC6",
                "fill-opacity": 0.25
            }
        };

        const lineStyle = {
            id: `wards-line-${layer.id}`,
            type: "line",
            source: layer.id,
            paint: {
                "line-color": "#ffffff",
                "line-width": 2.5,
                "line-opacity": 0.9
            }
        };

        if (layer.filter) {
            fillStyle.filter = layer.filter;
            lineStyle.filter = layer.filter;
        }

        this._map.addLayer(fillStyle, "polygons");
        this._map.addLayer(lineStyle, "polygons");

        this._map.on("click", `wards-fill-${layer.id}`, this.layerClickedBinded);
    }

    removeLayer(layer) {
        // Удаляем подписи при удалении слоя
        this.removeLabels(layer);

        const layerObj = this._map.getLayer(`wards-line-${layer.id}`);
        if (layerObj) {
            this._map.removeLayer(`wards-line-${layer.id}`);
        }

        const layerFill = this._map.getLayer(`wards-fill-${layer.id}`);
        if (layerFill) {
            this._map.removeLayer(`wards-fill-${layer.id}`);
        }
        this._map.off("click", `wards-fill-${layer.id}`, this.layerClickedBinded);
    }

    onRemove() {
        this.layers.forEach((layer) => {
            this.removeLayer(layer);
        });
        this._container.parentNode?.removeChild(this._container);
        delete this._map;
    }

    // Добавляем новые методы для работы с подписями
    addLabels(layer) {
        const labelId = `${layer.id}-labels`;
        if (this._map.getLayer(labelId)) return;

        const labelLayer = {
            id: labelId,
            type: "symbol",
            source: layer.id,
            layout: {
                "text-field": layer.id === "pc" ? ["get", "name"] : ["get", "WD24NM"],
                "text-size": 14,
                "text-anchor": "center"
            },
            paint: {
                "text-color": "#000000",
                "text-halo-color": "#ffffff",
                "text-halo-width": 1.5
            }
        };

        // Применяем фильтр для postcodes
        if (layer.id === "pc" && layer.filter) {
            labelLayer.filter = pcFilter;
        }

        this._map.addLayer(labelLayer);
    }

    removeLabels(layer) {
        const labelId = `${layer.id}-labels`;
        if (this._map.getLayer(labelId)) {
            this._map.removeLayer(labelId);
        }
    }
}

export default wardControl;
